/**
 * Integration catalog types used by `GET /pay/org/:orgId/integrations`.
 *
 * The endpoint returns a list of supported third-party integrations and their
 * organization-specific activation status. The catalog is assembled in
 * PayService.listAvailableIntegrations.
 */
import { XeroConnectionDetailsPayload } from './xero/types'

/** List of identifiers for each supported third-party integration. */
export enum IntegrationKey {
  /** Xero expenses synchronization integration. */
  XERO_EXPENSES = 'xero_expenses',
}

/** Activation status of an integration for a specific org. */
export enum IntegrationStatus {
  /** Integration is configured/connected for the organization. */
  ACTIVE = 'ACTIVE',
  /** Integration is available but not configured/connected for the organization. */
  INACTIVE = 'INACTIVE',
}

/** API payload for one integration catalog item. */
export type IntegrationPayload = {
  /** Stable machine-readable integration identifier. */
  key: IntegrationKey
  /** Human-readable integration name for UI display. */
  name: string
  /** Current activation status for the organization. */
  status: IntegrationStatus
  /** Temporary integration-specific details until the catalog is generalized for multiple providers. */
  data?: XeroConnectionDetailsPayload // | add more types here and use a type field enum so the client can handle the different types (for the future)
}
